   <div class="conetent-grid">       
    <div  class="img">         
        <div class="imgtext"><p>Start Your eZintegrations<sup>TM</sup> Journey</p></div>
    </div>   
    <div class="popup-content">  
        <p><b>Welcome to Bizdata Inc</b></p>
          <p>eZintegrations<sup>TM</sup> is a easiest and fastest way to integrate data between any apps,systems or sources. Connect data from any source in real time without any coding expertise.
            <b>Integrate Now</b></p>
        
    </div>    
</div>
   
  
 

